import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getCountry(params) {
    let { baseUrl, brandId, clientId, language, country } = params;

    invariant(baseUrl, 'baseUrl is a required param of getCountry()');
    invariant(brandId, 'brandId is a required param of getCountry()');
    invariant(clientId, 'clientId is a required param of getCountry()');
    invariant(language, 'language is a required param of getCountry()');
    invariant(country, 'country is a required param of getCountry()');

    const url = `${baseUrl}wcs/resources/store/${brandId}/v2/countries/language/${language}/country/${country}`;
    return labelRequest(authenticatedRequest(new Request(url), null, clientId), 'getCountry');
}
